import React from 'react'

export default function NewFooter() {
    return (
        <div className="footer-block hidden col-12 p-1 m-0 bg-primary text-center  bottom-0 lg:block" style={{fontSize: '14px'}}>
         &copy; {new Date().getFullYear()}, Chinmmai Systemss Private Limited. All Rights Reserved.
        </div>
    )
}
